// extracted by mini-css-extract-plugin
export var component = "TextContent-module--component--euq2b";